module.exports = __webpack_public_path__ + "static/media/newsletters.b9285e37.png";